import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ShieldCheck, CreditCard, ChevronDown, Star, AlertTriangle, BookOpen, TrendingUp, Briefcase, FileText, Lock, Zap, Globe, Landmark } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { SocialProofPopup } from './SocialProofPopup';
const IMAGES = {
  MAIN: 'https://cdn.magicpatterns.com/uploads/dhx7dLRSgXUDNNwv5T297U/mockups_economia_politica_.png'
};
const LINKS = {
  BASIC: 'https://checkout.kitonline.shop/cart/47832138383598:1',
  PREMIUM: 'https://checkout.kitonline.shop/cart/47832142577902:1'
};
export function SalesPage() {
  const [openCuadernillo, setOpenCuadernillo] = useState<number | null>(null);
  const [selectedPack, setSelectedPack] = useState(1); // 0=basic, 1=premium
  const packLinks = [LINKS.BASIC, LINKS.PREMIUM];
  // Urgency countdown (2h 10m 04s from page load)
  const [urgencyTime, setUrgencyTime] = useState({
    hours: 2,
    minutes: 10,
    seconds: 4
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setUrgencyTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          hours = 0;
          minutes = 0;
          seconds = 0;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="font-sans text-gray-200 bg-[#080c1a] min-h-screen flex flex-col selection:bg-[#22c55e] selection:text-white" data-id="element-1">
      <CountdownTimer data-id="element-2" />
      <SocialProofPopup data-id="element-3" />

      {/* SECTION 1: HERO */}
      <section className="bg-[#0a0e1f] py-4 md:py-12 px-3 md:px-4 text-center border-b border-[#1e2a5a]" data-id="element-4">
        <div className="max-w-4xl mx-auto" data-id="element-5">
          <span className="inline-block border border-[#eab308] text-[#eab308] text-[10px] md:text-sm font-bold uppercase tracking-widest mb-2 md:mb-5 px-3 py-1 rounded-full whitespace-nowrap shadow-[0_0_12px_rgba(234,179,8,0.25)] bg-[#eab308]/10" data-id="element-6">
            Para docentes de Economía Política en secundaria
          </span>

          <h1 className="text-3xl md:text-6xl lg:text-7xl font-black text-white mb-2 md:mb-6 leading-tight tracking-tight" data-id="element-7">
            Todo tu año de Economía Política{' '}
            <span className="text-[#22c55e]" data-id="element-8">resuelto.</span>
          </h1>

          <div onClick={scrollToPricing} className="cursor-pointer hover:scale-105 transition-transform duration-300 my-2 md:my-8 relative" data-id="element-9">
            <div className="absolute inset-0 bg-[#3b82f6] blur-[100px] opacity-20 rounded-full pointer-events-none" data-id="element-10"></div>
            <img src={IMAGES.MAIN} alt="Kit Completo Economía Política" className="w-full max-w-xs md:max-w-2xl mx-auto drop-shadow-[0_20px_50px_rgba(59,130,246,0.3)] relative z-10" data-id="element-11" />
          </div>

          <p className="text-sm md:text-xl text-gray-300 mb-3 md:mb-6 max-w-3xl mx-auto leading-relaxed font-medium" data-id="element-12">
            Mientras otros docentes todavía están buscando materiales
            actualizados,{' '}
            <span className="text-[#eab308] font-bold" data-id="element-13">
              vos tenés todo el año armado
            </span>
            : planificación, teoría desarrollada, actividades, debates y
            evaluaciones listas para el aula.
          </p>

          <div className="flex flex-wrap justify-center gap-1.5 md:gap-3 mb-3 md:mb-8" data-id="element-14">
            <span className="flex items-center gap-1.5 bg-[#111633] border border-[#22c55e]/30 text-gray-200 text-[11px] md:text-sm px-3 py-1.5 rounded-full font-semibold shadow-[0_0_10px_rgba(34,197,94,0.1)]" data-id="element-15">
              <FileText className="w-3 h-3 md:w-4 md:h-4 text-[#22c55e]" data-id="element-16" /> 100%
              PDF
            </span>
            <span className="flex items-center gap-1.5 bg-[#111633] border border-[#22c55e]/30 text-gray-200 text-[11px] md:text-sm px-3 py-1.5 rounded-full font-semibold shadow-[0_0_10px_rgba(34,197,94,0.1)]" data-id="element-17">
              <Zap className="w-3 h-3 md:w-4 md:h-4 text-[#22c55e]" data-id="element-18" /> Acceso
              inmediato
            </span>
            <span className="flex items-center gap-1.5 bg-[#111633] border border-[#22c55e]/30 text-gray-200 text-[11px] md:text-sm px-3 py-1.5 rounded-full font-semibold shadow-[0_0_10px_rgba(34,197,94,0.1)]" data-id="element-19">
              🇦🇷 Adaptado a NAP Argentina
            </span>
            <span className="flex items-center gap-1.5 bg-[#111633] border border-[#22c55e]/30 text-gray-200 text-[11px] md:text-sm px-3 py-1.5 rounded-full font-semibold shadow-[0_0_10px_rgba(34,197,94,0.1)]" data-id="element-20">
              🎓 Para 4º, 5º y 6º año
            </span>
          </div>

          <button onClick={scrollToPricing} className="w-full md:w-auto inline-flex items-center justify-center bg-[#22c55e] hover:bg-[#16a34a] text-white font-black text-base md:text-2xl py-3 px-5 md:py-5 md:px-12 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.4)] transform hover:scale-105 transition-all duration-200 mb-3 md:mb-6 uppercase tracking-wide border-2 border-[#4ade80]" data-id="element-21">
            → QUIERO MI KIT COMPLETO AHORA
          </button>

          <div className="flex flex-wrap justify-center gap-2 md:gap-6 text-[10px] md:text-sm text-gray-400 font-medium" data-id="element-22">
            <span className="flex items-center gap-1" data-id="element-23">
              <ShieldCheck className="w-4 h-4 text-[#22c55e]" data-id="element-24" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1" data-id="element-25">
              <Lock className="w-4 h-4 text-[#22c55e]" data-id="element-26" /> Pago seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-27">
              <CreditCard className="w-4 h-4 text-[#22c55e]" data-id="element-28" /> Mercado Pago
            </span>
          </div>
        </div>
      </section>

      {/* SECTION 2: SOCIAL PROOF STRIP */}
      <section className="bg-[#111633] py-2.5 md:py-4 px-3 border-b border-[#1e2a5a]" data-id="element-29">
        <div className="max-w-md mx-auto flex items-center justify-center gap-3" data-id="element-30">
          <div className="flex items-center -space-x-2.5" data-id="element-31">
            {['#3b82f6', '#a855f7', '#22c55e', '#ef4444'].map((color, i) => <div key={i} className="w-8 h-8 md:w-10 md:h-10 rounded-full border-2 border-[#111633] flex items-center justify-center text-white font-bold text-[10px] md:text-xs shadow-sm" style={{
            backgroundColor: color,
            zIndex: 4 - i
          }} data-id="element-32">
                {['MC', 'LP', 'SR', '+'][i]}
              </div>)}
          </div>
          <div className="flex flex-col" data-id="element-33">
            <p className="text-white text-sm md:text-base font-bold leading-tight" data-id="element-34">
              <span className="text-[#22c55e]" data-id="element-35">+1.800 docentes</span> arrancaron
              el año con el kit
            </p>
            <div className="flex items-center gap-0.5 mt-0.5" data-id="element-36">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 md:w-4 md:h-4 fill-[#eab308] text-[#eab308]" data-id="element-37" />)}
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 3: PAIN POINTS */}
      <section className="bg-[#080c1a] py-4 md:py-16 px-3" data-id="element-38">
        <div className="max-w-3xl mx-auto" data-id="element-39">
          <h2 className="text-xl md:text-4xl font-black text-center text-white mb-3 md:mb-10 uppercase italic leading-tight" data-id="element-40">
            Si sos docente de Economía Política,{' '}
            <span className="text-[#eab308] underline decoration-[#eab308]/30 decoration-4 underline-offset-4 not-italic" data-id="element-41">
              esto te va a sonar familiar…
            </span>
          </h2>

          <div className="space-y-2 md:space-y-4 mb-3 md:mb-10" data-id="element-42">
            {[{
            emoji: '📋',
            text: <>
                    <span className="font-bold text-white" data-id="element-43">
                      Armás clases desde cero
                    </span>{' '}
                    una y otra vez sobre inflación, PBI y sistemas económicos,
                    perdiendo horas de tu tiempo libre que jamás recuperás.
                  </>
          }, {
            emoji: '🤢',
            text: <>
                    <span className="font-bold text-white" data-id="element-44">
                      Los manuales escolares están desactualizados
                    </span>
                    , no tienen contexto argentino real y los alumnos los
                    cierran a los cinco minutos.
                  </>
          }, {
            emoji: '😢',
            text: <>
                    <span className="font-bold text-white" data-id="element-45">
                      Hablás de macroeconomía y los chicos te miran
                    </span>{' '}
                    como si hablaras en otro idioma. Necesitás ejemplos del
                    mundo real y no tenés tiempo para buscarlos clase a clase.
                  </>
          }, {
            emoji: '🏚️',
            text: <>
                    <span className="font-bold text-white" data-id="element-46">
                      El tema "inflación" o "dólar" aparece en el noticiero
                    </span>{' '}
                    y no sabés cómo trabajarlo sin que se convierta en un debate
                    político sin herramientas pedagógicas.
                  </>
          }, {
            emoji: '😓',
            text: <>
                    <span className="font-bold text-white" data-id="element-47">
                      Coordinación te pide planificaciones con objetivos NAP
                    </span>{' '}
                    y terminás gastando un fin de semana en burocracia que no
                    tiene nada que ver con enseñar.
                  </>
          }].map((pain, i) => <div key={i} className="flex items-start gap-3 bg-[#0d1229] rounded-xl p-3 md:p-5 border border-[#22c55e]/30 shadow-[0_0_15px_rgba(34,197,94,0.05)] hover:shadow-[0_0_20px_rgba(34,197,94,0.15)] transition-shadow" data-id="element-48">
                <span className="text-2xl md:text-3xl flex-shrink-0" data-id="element-49">
                  {pain.emoji}
                </span>
                <p className="text-sm md:text-lg text-gray-300 leading-relaxed" data-id="element-50">
                  {pain.text}
                </p>
              </div>)}
          </div>

          <div className="text-center space-y-2 md:space-y-3 bg-[#111633] p-3 md:p-6 rounded-xl border border-[#1e2a5a]" data-id="element-51">
            <p className="text-base md:text-xl text-gray-300 font-bold" data-id="element-52">
              <span className="text-red-500" data-id="element-53">✖</span> No es falta de vocación.{' '}
              <span className="text-red-500" data-id="element-54">✖</span> No es falta de
              preparación.
            </p>
            <p className="text-lg md:text-2xl font-black text-[#22c55e]" data-id="element-55">
              👉 Es falta de un sistema claro, actualizado y listo para usar.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4: SOLUTION INTRO */}
      <section className="bg-[#0a0e1f] py-4 md:py-16 px-3 border-y border-[#1e2a5a]" data-id="element-56">
        <div className="max-w-4xl mx-auto" data-id="element-57">
          <h2 className="text-xl md:text-4xl font-black text-center text-white mb-1 leading-tight" data-id="element-58">
            Por eso creamos el{' '}
            <span className="text-[#3b82f6]" data-id="element-59">
              KIT COMPLETO ECONOMÍA POLÍTICA
            </span>
          </h2>
          <p className="text-center text-xs md:text-lg text-gray-400 mb-3 md:mb-10 max-w-2xl mx-auto" data-id="element-60">
            Un sistema pensado para docentes argentinos de secundaria que
            quieren dejar de improvisar y entrar al aula con todo resuelto.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-2 gap-2 md:gap-4 mb-3 md:mb-8" data-id="element-61">
            {[{
            icon: '📋',
            title: 'Todo el año organizado',
            desc: '6 tomos listos para 4º, 5º y 6º año.'
          }, {
            icon: '✅',
            title: 'Clases listas para aplicar',
            desc: 'Teoría, actividades y debates sin empezar de cero.'
          }, {
            icon: '📘',
            title: 'Contenidos actualizados',
            desc: 'Inflación, PBI, mercado de trabajo y economía internacional con ejemplos de Argentina real.'
          }, {
            icon: '😌',
            title: 'Más tiempo y tranquilidad',
            desc: 'Recuperá tus fines de semana de una vez por todas.'
          }].map((feature, i) => <div key={i} className="bg-[#0d1229] rounded-xl p-3 md:p-6 border border-[#22c55e]/30 shadow-[0_0_15px_rgba(34,197,94,0.1)] flex items-start gap-3" data-id="element-62">
                <span className="text-2xl md:text-3xl" data-id="element-63">{feature.icon}</span>
                <div data-id="element-64">
                  <h3 className="font-bold text-base md:text-lg text-white mb-1" data-id="element-65">
                    {feature.title}
                  </h3>
                  <p className="text-sm md:text-base text-gray-400 leading-snug" data-id="element-66">
                    {feature.desc}
                  </p>
                </div>
              </div>)}
          </div>

          <p className="text-center text-lg md:text-2xl font-black text-[#eab308]" data-id="element-67">
            ✨ Menos estrés. Más orden. Más disfrute al dar clase.
          </p>
        </div>
      </section>

      {/* SECTION 5: EXTRA PERSUASIVE CTA */}
      <section className="bg-[#080c1a] py-4 md:py-8 px-3 text-center" data-id="element-68">
        <button onClick={scrollToPricing} className="w-full max-w-2xl mx-auto inline-flex items-center justify-center bg-[#eab308] hover:bg-[#ca8a04] text-black font-black text-lg md:text-2xl py-3 px-6 md:py-6 md:px-10 rounded-xl shadow-[0_0_40px_rgba(234,179,8,0.4)] transform hover:scale-105 transition-all duration-200 uppercase tracking-wide border-2 border-[#fef08a]" data-id="element-69">
          🔥 ACCEDÉ AL KIT ANTES DE QUE SUBA EL PRECIO →
        </button>
      </section>

      {/* SECTION 6: CONTENTS */}
      <section className="bg-[#0a0e1f] py-4 md:py-20 px-3 border-t border-[#1e2a5a]" data-id="element-70">
        <div className="max-w-4xl mx-auto" data-id="element-71">
          <div className="text-center mb-3 md:mb-12" data-id="element-72">
            <h2 className="text-3xl md:text-5xl font-black text-white mb-3" data-id="element-73">
              📦 ¿QUÉ INCLUYE EL{' '}
              <span className="text-[#22c55e]" data-id="element-74">KIT COMPLETO</span>?
            </h2>
            <p className="text-lg md:text-xl text-gray-400" data-id="element-75">
              ✅ Tocá cada tomo para ver su contenido en detalle
            </p>
          </div>

          <div className="space-y-2 md:space-y-4" data-id="element-76">
            {[{
            title: 'TOMO 1 — FUNDAMENTOS Y SISTEMAS ECONÓMICOS',
            subtitle: '¿Para qué sirve la economía y cuáles son los grandes sistemas?',
            icon: BookOpen,
            color: 'text-blue-400',
            items: ['Qué es la Economía Política y por qué el apellido importa', 'Necesidades, recursos, escasez y costo de oportunidad', 'Capitalismo: Smith, la Mano Invisible y la Escuela Clásica', 'Socialismo y Comunismo: Marx, la plusvalía y la lucha de clases', 'Economía Mixta: Keynes y el Estado de Bienestar', 'Debates actuales: neoliberalismo, modelo nórdico y caso argentino']
          }, {
            title: 'TOMO 2 — MICROECONOMÍA EN EL SIGLO XXI',
            subtitle: 'El tomo que convierte al alumno en un consumidor consciente.',
            icon: TrendingUp,
            color: 'text-red-400',
            items: ['Valor de uso vs. valor de cambio y la paradoja del agua y los diamantes', 'Demanda: ley, determinantes e inflación argentina', 'Oferta: costos, remarcación preventiva y espiral precio-salario', 'Equilibrio de mercado, precio máximo y precio mínimo', 'Competencia, monopolio y oligopolio con casos argentinos reales', 'Fallas de mercado, sesgos cognitivos y derechos del consumidor']
          }, {
            title: 'TOMO 3 — MACROECONOMÍA ARGENTINA',
            subtitle: 'El tomo más urgente: inflación, dólar, BCRA y crisis.',
            icon: Landmark,
            color: 'text-green-400',
            items: ['PBI nominal vs. real y sus limitaciones como medida de bienestar', 'Inflación: medición, tres teorías explicativas e historia argentina', 'El dinero y el sistema financiero: funciones y multiplicador bancario', 'El BCRA: instrumentos de política monetaria y bimonetariedad', 'El Stop and Go argentino y los ciclos de crisis recurrentes']
          }, {
            title: 'TOMO 4 — EL MUNDO DEL TRABAJO Y LA DESIGUALDAD',
            subtitle: 'El tomo que conecta la economía con la vida real de las familias.',
            icon: Briefcase,
            color: 'text-orange-400',
            items: ['Mercado de trabajo: PEA, desempleo, subocupación y desalentados', 'Historia laboral argentina: del movimiento obrero al Cordobazo', 'Sindicatos, paritarias y negociación colectiva', 'Empleo informal, plataformas digitales y precarización laboral', 'Distribución del ingreso, Coeficiente de Gini y políticas redistributivas', 'Economía del cuidado y brecha salarial de género']
          }, {
            title: 'TOMO 5 — SECTOR PÚBLICO, IMPUESTOS Y DEUDA',
            subtitle: 'El tomo que explica por qué pagamos impuestos y qué hace el Estado.',
            icon: FileText,
            color: 'text-purple-400',
            items: ['El presupuesto nacional como decisión política, no solo técnica', 'IVA, Ganancias, Bienes Personales y Retenciones agropecuarias', 'Gasto público: social, subsidios, inversión y servicio de deuda', 'Déficit fiscal y sus tres formas de financiamiento', 'Historia de la deuda argentina en cinco actos', 'El FMI, las condicionalidades y la soberanía económica']
          }, {
            title: 'TOMO 6 — ECONOMÍA INTERNACIONAL Y DESARROLLO SUSTENTABLE',
            subtitle: 'El tomo que abre la mirada al mundo.',
            icon: Globe,
            color: 'text-teal-400',
            items: ['Comercio internacional: ventaja comparativa y política comercial', 'Balanza de pagos, restricción externa y fuga de capitales', 'Tipo de cambio, brecha cambiaria y bimonetariedad', 'Globalización, desglobalización y nuevos actores internacionales', 'Mercosur: historia, logros, tensiones y acuerdo con la UE', 'Litio, Vaca Muerta y el dilema del desarrollo sustentable argentino']
          }].map((tomo, idx) => <div key={idx} className="bg-[#0d1229] rounded-xl border border-[#22c55e]/30 overflow-hidden transition-all hover:shadow-[0_0_15px_rgba(34,197,94,0.15)]" data-id="element-77">
                <button onClick={() => setOpenCuadernillo(openCuadernillo === idx ? null : idx)} className="w-full flex items-center gap-3 md:gap-4 p-3 md:p-6 text-left cursor-pointer" data-id="element-78">
                  <tomo.icon className={`w-6 h-6 md:w-8 md:h-8 ${tomo.color} flex-shrink-0`} data-id="element-79" />
                  <div className="flex-1" data-id="element-80">
                    <h3 className="text-base md:text-xl font-bold text-white leading-tight" data-id="element-81">
                      {tomo.title}
                    </h3>
                    <p className="text-xs md:text-sm text-gray-400 mt-1" data-id="element-82">
                      {tomo.subtitle}
                    </p>
                  </div>
                  <ChevronDown className={`w-5 h-5 md:w-6 md:h-6 text-gray-500 flex-shrink-0 transition-transform duration-300 ${openCuadernillo === idx ? 'rotate-180' : ''}`} data-id="element-83" />
                </button>
                <AnimatePresence data-id="element-84">
                  {openCuadernillo === idx && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden bg-[#080c1a]" data-id="element-85">
                      <div className="px-4 md:px-8 pb-4 md:pb-6 pt-2 border-t border-[#1e2a5a]" data-id="element-86">
                        <ul className="space-y-2 md:space-y-3 text-gray-300 text-sm md:text-base" data-id="element-87">
                          {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-88">
                              <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-89" />
                              <span data-id="element-90">{item}</span>
                            </li>)}
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 7: BONUSES */}
      <section className="bg-[#080c1a] py-4 md:py-20 px-3 border-t border-[#1e2a5a]" data-id="element-91">
        <div className="max-w-5xl mx-auto" data-id="element-92">
          <div className="text-center mb-3 md:mb-12" data-id="element-93">
            <h2 className="text-3xl md:text-5xl font-black text-white mb-3 leading-tight" data-id="element-94">
              <span className="text-[#eab308]" data-id="element-95">BONUS EXCLUSIVOS</span> INCLUIDOS
              CON TU COMPRA
            </h2>
            <div className="inline-flex items-center gap-2 bg-red-600 text-white font-black text-sm md:text-xl px-4 md:px-8 py-2 md:py-3 rounded-lg shadow-[0_0_20px_rgba(220,38,38,0.4)] border border-red-400" data-id="element-96">
              <span className="text-lg md:text-2xl" data-id="element-97">🎁</span>
              ¡GRATIS POR EL DÍA DE HOY!
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-5 mb-3 md:mb-10" data-id="element-98">
            {[{
            num: '01',
            title: 'PLANIFICADOR ANUAL NAP "COPIAR-PEGAR"',
            desc: 'Objetivos, unidades, secuencias didácticas y evidencias listas para 4º, 5º y 6º. Copiás, ajustás mínimo y entregás.',
            val: '$15.000'
          }, {
            num: '02',
            title: 'BANCO DE ACTIVIDADES "NO SE DUERMEN"',
            desc: '32 dinámicas con guión docente, variantes por nivel y cierre con evidencia. Activadores, talleres, debates con roles y cierres rápidos.',
            val: '$12.000'
          }, {
            num: '03',
            title: 'EVALUACIÓN LISTA "SIN PELEAS POR LA NOTA"',
            desc: '12 rúbricas específicas, 36 consignas por año y plantillas de devolución para corregir en 2 minutos.',
            val: '$10.000'
          }, {
            num: '04',
            title: 'KIT "ACTUALIDAD PARA EL AULA"',
            desc: '36 guías para trabajar noticias económicas con preguntas por nivel. Funciona con cualquier noticia de hoy o del año que viene.',
            val: '$8.000'
          }].map((bonus, i) => <div key={i} className="relative bg-[#0d1229] rounded-xl border border-[#22c55e]/40 overflow-hidden p-3 md:p-6 flex flex-col shadow-[0_0_15px_rgba(34,197,94,0.1)]" data-id="element-99">
                <span className="absolute top-2 right-3 text-[60px] md:text-[80px] font-black text-white/[0.03] leading-none select-none pointer-events-none" data-id="element-100">
                  {bonus.num}
                </span>
                <span className="inline-block bg-[#eab308] text-black text-[10px] md:text-xs font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider mb-3 self-start" data-id="element-101">
                  BONUS #{bonus.num}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-white mb-2 leading-tight" data-id="element-102">
                  {bonus.title}
                </h3>
                <p className="text-gray-400 text-sm md:text-base leading-relaxed flex-1 mb-4" data-id="element-103">
                  {bonus.desc}
                </p>
                <div className="flex items-center justify-between pt-3 border-t border-[#1e2a5a]" data-id="element-104">
                  <span className="text-gray-500 text-sm line-through" data-id="element-105">
                    Valor {bonus.val}
                  </span>
                  <span className="bg-[#22c55e] text-white text-xs md:text-sm font-bold px-3 py-1 rounded-full uppercase tracking-wider shadow-[0_0_10px_rgba(34,197,94,0.4)]" data-id="element-106">
                    GRATIS
                  </span>
                </div>
              </div>)}
          </div>

          <div className="max-w-lg mx-auto bg-[#111633] border-2 border-[#22c55e] rounded-2xl p-3 md:p-8 text-center shadow-[0_0_30px_rgba(34,197,94,0.2)]" data-id="element-107">
            <p className="text-gray-400 text-base md:text-lg mb-1" data-id="element-108">
              Valor total de los 4 bonus:
            </p>
            <p className="text-white text-2xl md:text-3xl font-black line-through decoration-red-500 decoration-2 mb-2 md:mb-4" data-id="element-109">
              $45.000
            </p>
            <p className="text-gray-300 text-lg md:text-xl mb-1" data-id="element-110">
              Hoy te los llevás por:
            </p>
            <p className="text-[#22c55e] text-5xl md:text-7xl font-black mb-2 md:mb-4 drop-shadow-[0_0_15px_rgba(34,197,94,0.5)]" data-id="element-111">
              $0
            </p>
            <p className="text-[#eab308] font-bold text-sm md:text-lg uppercase tracking-wide" data-id="element-112">
              ✨ Incluidos GRATIS con tu compra de hoy ✨
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 8: URGENCY */}
      <section className="bg-[#0a0e1f] py-4 md:py-16 px-3 border-t border-[#1e2a5a]" data-id="element-113">
        <div className="max-w-3xl mx-auto text-center" data-id="element-114">
          <h2 className="text-2xl md:text-4xl font-black text-[#eab308] mb-4 md:mb-10 uppercase tracking-wide" data-id="element-115">
            El precio de lanzamiento termina en
          </h2>

          <div className="flex items-center justify-center gap-2 md:gap-6 mb-4 md:mb-10" data-id="element-116">
            <div className="flex flex-col items-center" data-id="element-117">
              <div className="bg-[#080c1a] border-2 border-red-500 rounded-xl w-16 h-16 md:w-28 md:h-28 flex items-center justify-center shadow-[0_0_20px_rgba(220,38,38,0.3)]" data-id="element-118">
                <span className="text-red-500 text-4xl md:text-6xl font-black" data-id="element-119">
                  {String(urgencyTime.hours).padStart(2, '0')}
                </span>
              </div>
              <span className="text-gray-400 text-xs md:text-sm font-bold uppercase tracking-wider mt-2" data-id="element-120">
                Horas
              </span>
            </div>
            <span className="text-red-500 text-3xl md:text-6xl font-black -mt-6" data-id="element-121">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-122">
              <div className="bg-[#080c1a] border-2 border-red-500 rounded-xl w-16 h-16 md:w-28 md:h-28 flex items-center justify-center shadow-[0_0_20px_rgba(220,38,38,0.3)]" data-id="element-123">
                <span className="text-red-500 text-4xl md:text-6xl font-black" data-id="element-124">
                  {String(urgencyTime.minutes).padStart(2, '0')}
                </span>
              </div>
              <span className="text-gray-400 text-xs md:text-sm font-bold uppercase tracking-wider mt-2" data-id="element-125">
                Minutos
              </span>
            </div>
            <span className="text-red-500 text-3xl md:text-6xl font-black -mt-6" data-id="element-126">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-127">
              <div className="bg-[#080c1a] border-2 border-red-500 rounded-xl w-16 h-16 md:w-28 md:h-28 flex items-center justify-center shadow-[0_0_20px_rgba(220,38,38,0.3)]" data-id="element-128">
                <span className="text-red-500 text-4xl md:text-6xl font-black" data-id="element-129">
                  {String(urgencyTime.seconds).padStart(2, '0')}
                </span>
              </div>
              <span className="text-gray-400 text-xs md:text-sm font-bold uppercase tracking-wider mt-2" data-id="element-130">
                Segundos
              </span>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-1.5 md:gap-4 mb-4 md:mb-10" data-id="element-131">
            <span className="bg-[#111633] border border-[#1e2a5a] text-gray-300 text-xs md:text-sm font-bold px-4 py-2 rounded-lg" data-id="element-132">
              🔥 Últimas unidades disponibles
            </span>
            <span className="bg-[#111633] border border-[#1e2a5a] text-gray-300 text-xs md:text-sm font-bold px-4 py-2 rounded-lg" data-id="element-133">
              📢 Oferta de Lanzamiento
            </span>
            <span className="bg-[#111633] border border-[#1e2a5a] text-gray-300 text-xs md:text-sm font-bold px-4 py-2 rounded-lg" data-id="element-134">
              📈 Precio sube al terminar
            </span>
          </div>

          <div className="max-w-lg mx-auto" data-id="element-135">
            <div className="relative w-full h-4 md:h-5 bg-[#080c1a] rounded-full overflow-hidden border border-[#1e2a5a]" data-id="element-136">
              <div className="h-full rounded-full bg-gradient-to-r from-orange-500 to-red-600" style={{
              width: '72%'
            }} data-id="element-137" />
            </div>
            <p className="text-gray-400 text-xs md:text-sm font-bold mt-2 uppercase tracking-wider" data-id="element-138">
              72 % de cupos ocupados
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 9: PRICING */}
      <section id="pricing" className="bg-[#080c1a] py-4 md:py-20 px-3 border-t border-[#1e2a5a]" data-id="element-139">
        <div className="max-w-5xl mx-auto" data-id="element-140">
          <h2 className="text-3xl md:text-5xl font-black text-white text-center mb-4 md:mb-12 italic" data-id="element-141">
            Elegí tu{' '}
            <span className="text-[#22c55e] underline decoration-[#22c55e]/30 decoration-4 underline-offset-8" data-id="element-142">
              Pack Completo
            </span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-4 md:mb-12 max-w-4xl mx-auto" data-id="element-143">
            {/* Option 1: Basic */}
            <button onClick={() => setSelectedPack(0)} className={`relative text-left rounded-2xl p-4 md:p-8 transition-all duration-200 cursor-pointer flex flex-col h-full ${selectedPack === 0 ? 'bg-[#111633] border-2 border-[#22c55e] shadow-[0_0_30px_rgba(34,197,94,0.2)]' : 'bg-[#0d1229] border-2 border-[#1e2a5a] hover:border-[#3b82f6]/50'}`} data-id="element-144">
              <div className={`absolute top-3 right-3 w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPack === 0 ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-600'}`} data-id="element-145">
                {selectedPack === 0 && <Check className="w-3 h-3 text-white" data-id="element-146" />}
              </div>
              <div className="text-2xl mb-1" data-id="element-147">📚</div>
              <h3 className="text-lg md:text-2xl font-black text-white mb-1 pr-7" data-id="element-148">
                Kit Completo{' '}
                <span className="text-[#3b82f6]" data-id="element-149">Economía Política</span>
              </h3>
              <p className="text-gray-400 text-xs md:text-base mb-3 flex-1" data-id="element-150">
                6 tomos completos + 4 bonus
              </p>
              <div className="mt-auto pt-3 border-t border-[#1e2a5a]" data-id="element-151">
                <span className="text-gray-500 text-xs md:text-base line-through block mb-1" data-id="element-152">
                  Precio normal: $39.990
                </span>
                <div className="flex items-baseline gap-2" data-id="element-153">
                  <span className="text-3xl md:text-5xl font-black text-white" data-id="element-154">
                    $19.990
                  </span>
                </div>
              </div>
            </button>

            {/* Option 2: Premium */}
            <button onClick={() => setSelectedPack(1)} className={`relative text-left rounded-2xl p-4 md:p-8 transition-all duration-200 cursor-pointer flex flex-col h-full ${selectedPack === 1 ? 'bg-[#111633] border-2 border-[#22c55e] shadow-[0_0_30px_rgba(34,197,94,0.2)]' : 'bg-[#0d1229] border-2 border-[#1e2a5a] hover:border-[#3b82f6]/50'}`} data-id="element-155">
              <span className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-[#eab308] text-black text-[10px] md:text-sm font-black px-3 py-0.5 rounded-full uppercase tracking-wider whitespace-nowrap shadow-[0_0_15px_rgba(234,179,8,0.4)]" data-id="element-156">
                ⭐ Más elegido
              </span>
              <div className={`absolute top-3 right-3 w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPack === 1 ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-600'}`} data-id="element-157">
                {selectedPack === 1 && <Check className="w-3 h-3 text-white" data-id="element-158" />}
              </div>
              <div className="text-2xl mb-1" data-id="element-159">🎓</div>
              <h3 className="text-lg md:text-2xl font-black text-white mb-1 pr-7" data-id="element-160">
                Kit Completo +{' '}
                <span className="text-[#eab308]" data-id="element-161">Academia de Simulación</span>
              </h3>
              <p className="text-gray-400 text-xs md:text-base mb-3 flex-1" data-id="element-162">
                Kit completo + 4 proyectos de inmersión + 20 escenarios de
                crisis
              </p>
              <div className="mt-auto pt-3 border-t border-[#1e2a5a]" data-id="element-163">
                <span className="text-gray-500 text-xs md:text-base line-through block mb-1" data-id="element-164">
                  Precio normal: $59.990
                </span>
                <div className="flex items-baseline gap-2" data-id="element-165">
                  <span className="text-3xl md:text-5xl font-black text-white" data-id="element-166">
                    $27.990
                  </span>
                </div>
              </div>
            </button>
          </div>

          <div className="text-center mb-4 md:mb-12" data-id="element-167">
            <a href={packLinks[selectedPack]} className="inline-flex items-center justify-center gap-2 w-full md:w-auto bg-[#22c55e] hover:bg-[#16a34a] text-white font-black text-lg md:text-3xl py-3 px-6 md:py-6 md:px-20 rounded-xl shadow-[0_0_40px_rgba(34,197,94,0.4)] transform hover:scale-[1.02] transition-all duration-200 border-2 border-[#4ade80] uppercase tracking-wide" data-id="element-168">
              → SÍ, QUIERO MI PACK
            </a>
            <p className="text-gray-400 text-xs md:text-base font-bold mt-3 flex items-center justify-center gap-2" data-id="element-169">
              <Lock className="w-4 h-4 text-[#22c55e]" data-id="element-170" /> PAGO SEGURO CON
              MERCADO PAGO
            </p>
          </div>

          <div className="max-w-2xl mx-auto bg-[#0d1229] border border-[#22c55e]/40 rounded-2xl p-3 md:p-8 shadow-[0_0_20px_rgba(34,197,94,0.1)]" data-id="element-171">
            <h3 className="text-white font-black text-lg md:text-xl mb-4 md:mb-6 flex items-center gap-2 justify-center border-b border-[#1e2a5a] pb-4" data-id="element-172">
              👑 PACK COMPLETO INCLUYE:
            </h3>
            <ul className="space-y-2 md:space-y-3" data-id="element-173">
              {['6 tomos de contenido desarrollado', 'Planificador Anual NAP listo para entregar', '32 actividades con variantes por nivel', 'Rúbricas y consignas de evaluación listas', '36 guías de actualidad con preguntas por nivel', 'Entrega inmediata por Drive (PDF)', 'Acceso de por vida sin vencimiento', 'Garantía de satisfacción de 7 días'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-200 text-xs md:text-base font-medium" data-id="element-174">
                  <Check className="w-5 h-5 md:w-6 md:h-6 text-[#22c55e] flex-shrink-0" data-id="element-175" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* SECTION 10: HOW IT WORKS */}
      <section className="bg-[#0a0e1f] py-4 md:py-16 px-3 border-t border-[#1e2a5a]" data-id="element-176">
        <div className="max-w-4xl mx-auto text-center" data-id="element-177">
          <h2 className="text-xl md:text-4xl font-black text-white mb-4 md:mb-12" data-id="element-178">
            ¿Cómo recibís el <span className="text-[#22c55e]" data-id="element-179">material</span>?
          </h2>

          <div className="grid grid-cols-3 gap-2 md:grid-cols-3 md:gap-8" data-id="element-180">
            {[{
            step: '1',
            title: 'Comprás',
            desc: 'Realizás la compra e ingresás tu correo.'
          }, {
            step: '2',
            title: 'Pagás',
            desc: 'Finalizás el pago de forma segura con Mercado Pago.'
          }, {
            step: '3',
            title: 'Descargás',
            desc: 'Recibís el link de descarga inmediata en tu correo.'
          }].map((s, i) => <div key={i} className="bg-[#0d1229] p-3 md:p-6 rounded-xl border border-[#22c55e]/20 shadow-[0_0_15px_rgba(34,197,94,0.05)] relative" data-id="element-181">
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-8 h-8 md:w-12 md:h-12 bg-[#22c55e] rounded-full flex items-center justify-center text-base md:text-2xl font-black text-white shadow-[0_0_15px_rgba(34,197,94,0.4)] border-3 md:border-4 border-[#0a0e1f]" data-id="element-182">
                  {s.step}
                </div>
                <h3 className="text-sm md:text-xl font-bold text-white mt-3 md:mt-4 mb-1 md:mb-2" data-id="element-183">
                  {s.title}
                </h3>
                <p className="text-gray-400 text-[11px] md:text-base leading-tight" data-id="element-184">
                  {s.desc}
                </p>
              </div>)}
          </div>

          <div className="mt-4 md:mt-12 bg-[#eab308]/10 border border-[#eab308]/30 rounded-lg p-2 md:p-4 inline-block" data-id="element-185">
            <p className="text-[#eab308] flex items-center justify-center gap-1.5 font-bold text-xs md:text-base" data-id="element-186">
              <AlertTriangle className="w-4 h-4 md:w-5 md:h-5" data-id="element-187" />
              Si no lo ves en tu bandeja, revisá spam.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 11: GUARANTEE */}
      <section className="bg-[#080c1a] py-4 md:py-16 px-3 border-t border-[#1e2a5a]" data-id="element-188">
        <div className="max-w-3xl mx-auto text-center bg-[#0d1229] p-4 md:p-10 rounded-2xl border border-[#22c55e]/40 shadow-[0_0_30px_rgba(34,197,94,0.1)]" data-id="element-189">
          <ShieldCheck className="w-12 h-12 md:w-24 md:h-24 text-[#22c55e] mx-auto mb-2 md:mb-6 drop-shadow-[0_0_15px_rgba(34,197,94,0.4)]" data-id="element-190" />
          <h2 className="text-2xl md:text-4xl font-black text-white mb-2 md:mb-4" data-id="element-191">
            Garantía de{' '}
            <span className="text-[#22c55e]" data-id="element-192">Satisfacción Total</span>
          </h2>
          <p className="text-base md:text-xl text-gray-300 font-medium" data-id="element-193">
            Probalo 7 días. Si no cumple tus expectativas, te devolvemos el
            100%. Sin preguntas.
          </p>
        </div>
      </section>

      {/* SECTION 12: TESTIMONIALS */}
      <section className="bg-[#0a0e1f] py-4 md:py-20 px-3 border-t border-[#1e2a5a]" data-id="element-194">
        <div className="max-w-6xl mx-auto" data-id="element-195">
          <h2 className="text-2xl md:text-5xl font-black text-center text-white mb-4 md:mb-16" data-id="element-196">
            Lo que dicen los docentes que{' '}
            <span className="text-[#eab308]" data-id="element-197">ya lo usan</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-6" data-id="element-198">
            {[{
            text: 'Ahora organizo todo el año sin estrés. Por primera vez entro al aula sabiendo exactamente qué voy a hacer.',
            author: 'Natalia G., 42 años',
            loc: 'Córdoba'
          }, {
            text: 'Mis alumnos de 5to entienden la inflación porque el material conecta con lo que viven en sus casas.',
            author: 'Martín R., 35 años',
            loc: 'Buenos Aires'
          }, {
            text: 'Las secuencias didácticas me ahorraron meses de trabajo. La clase fluye sola.',
            author: 'Laura P., 48 años',
            loc: 'Mendoza'
          }, {
            text: 'El Proyecto País en Crisis los enganchó como ninguna otra actividad que hice en años.',
            author: 'Diego F., 38 años',
            loc: 'Tucumán'
          }, {
            text: 'Como profesora nueva en la materia, este kit fue mi salvavidas desde el primer día.',
            author: 'Valeria S., 29 años',
            loc: 'Santa Fe'
          }].map((t, i) => <div key={i} className="bg-[#0d1229] p-3 md:p-8 rounded-xl border border-[#22c55e]/20 shadow-[0_0_15px_rgba(34,197,94,0.05)] flex flex-col h-full" data-id="element-199">
                <div className="flex gap-0.5 text-[#eab308] mb-2 md:mb-4" data-id="element-200">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 md:w-5 md:h-5 fill-current" data-id="element-201" />)}
                </div>
                <p className="text-gray-300 mb-3 md:mb-6 text-sm md:text-lg italic flex-1" data-id="element-202">
                  "{t.text}"
                </p>
                <div className="border-t border-[#1e2a5a] pt-2 md:pt-4" data-id="element-203">
                  <div className="font-bold text-white text-xs md:text-base" data-id="element-204">
                    {t.author}
                  </div>
                  <div className="text-[#22c55e] text-[11px] md:text-sm font-semibold" data-id="element-205">
                    {t.loc}
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 13: FAQ */}
      <section className="bg-[#080c1a] py-4 md:py-20 px-3 border-t border-[#1e2a5a]" data-id="element-206">
        <div className="max-w-4xl mx-auto" data-id="element-207">
          <h2 className="text-2xl md:text-5xl font-black text-center text-white mb-4 md:mb-12" data-id="element-208">
            Preguntas <span className="text-[#22c55e]" data-id="element-209">Frecuentes</span>
          </h2>

          <div className="space-y-2 md:space-y-4" data-id="element-210">
            {[{
            q: '¿En qué formato recibo el material?',
            a: 'Todo en PDF de alta calidad, accesible desde un link de Google Drive que llega a tu correo inmediatamente después de la compra.'
          }, {
            q: '¿Puedo imprimir el material?',
            a: 'Sí. Todo está diseñado para ser impreso o usado en pantalla según lo que prefieras.'
          }, {
            q: '¿Para qué año de secundaria sirve?',
            a: 'Está diseñado específicamente para 4º, 5º y 6º año de la secundaria argentina con variantes de complejidad por nivel.'
          }, {
            q: '¿Cubre todos los temas del programa de Economía Política?',
            a: 'Sí. Los 6 tomos cubren todos los contenidos de los NAP: sistemas económicos, microeconomía, macroeconomía, trabajo, sector público y economía internacional.'
          }, {
            q: '¿El material está actualizado a la realidad argentina?',
            a: 'Sí. Incluye inflación reciente, mercado cambiario, datos del INDEC, economía de plataformas y recursos estratégicos como litio y Vaca Muerta.'
          }, {
            q: '¿Cuánto tarda en llegar?',
            a: 'El acceso es inmediato. En cuanto confirmamos tu pago recibís el link. Si no aparece, revisá spam.'
          }, {
            q: '¿Qué pasa si no me sirve?',
            a: 'Tenés 7 días para pedir el reembolso completo. Sin preguntas, sin formularios. Te devolvemos el 100%.'
          }, {
            q: '¿Puedo compartir el material con otros docentes?',
            a: 'El kit es de uso personal. Cada compra incluye acceso para un docente.'
          }, {
            q: '¿Sirve para escuelas técnicas o solo bachilleratos?',
            a: 'Sirve para cualquier modalidad de secundaria donde se dicte Economía Política como materia curricular.'
          }, {
            q: '¿Incluye solucionario de las actividades?',
            a: 'Sí. Todas las actividades incluyen orientaciones de respuesta para facilitar la corrección.'
          }].map((faq, i) => <details key={i} className="group bg-[#0d1229] rounded-xl border border-[#22c55e]/30 open:border-[#22c55e] transition-all duration-200 overflow-hidden shadow-[0_0_10px_rgba(34,197,94,0.05)]" data-id="element-211">
                <summary className="flex items-center justify-between cursor-pointer p-3 md:p-6 font-bold text-white list-none text-sm md:text-lg" data-id="element-212">
                  {faq.q}
                  <ChevronDown className="w-4 h-4 md:w-6 md:h-6 text-[#22c55e] group-open:rotate-180 transition-transform flex-shrink-0 ml-3" data-id="element-213" />
                </summary>
                <div className="px-3 pb-3 md:px-6 md:pb-6 text-gray-300 leading-relaxed border-t border-[#1e2a5a] pt-3 text-xs md:text-base" data-id="element-214">
                  {faq.a}
                </div>
              </details>)}
          </div>
        </div>
      </section>

      {/* SECTION 14: FINAL CTA */}
      <section className="bg-[#0a0e1f] py-4 md:py-24 px-3 text-center border-t border-[#1e2a5a]" data-id="element-215">
        <div className="max-w-4xl mx-auto" data-id="element-216">
          <h2 className="text-2xl md:text-5xl lg:text-6xl font-black text-white mb-3 md:mb-6 leading-tight" data-id="element-217">
            ¿Listo para{' '}
            <span className="text-[#22c55e]" data-id="element-218">transformar tu año</span> de
            Economía Política?
          </h2>
          <p className="text-lg md:text-2xl text-gray-400 mb-5 md:mb-12 font-medium" data-id="element-219">
            Sumate a los docentes que ya dejaron de improvisar.
          </p>
          
        </div>
      </section>

      {/* SECTION 15: BOTTOM PRICING (Duplicate) */}
      <section className="bg-[#080c1a] py-4 md:py-20 px-3 border-t border-[#1e2a5a]" data-id="element-220">
        <div className="max-w-5xl mx-auto" data-id="element-221">
          <h2 className="text-2xl md:text-5xl font-black text-white text-center mb-4 md:mb-12 italic" data-id="element-222">
            Elegí tu{' '}
            <span className="text-[#22c55e] underline decoration-[#22c55e]/30 decoration-4 underline-offset-8" data-id="element-223">
              Pack Completo
            </span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-4 md:mb-12 max-w-4xl mx-auto" data-id="element-224">
            {/* Option 1: Basic */}
            <button onClick={() => setSelectedPack(0)} className={`relative text-left rounded-2xl p-4 md:p-8 transition-all duration-200 cursor-pointer flex flex-col h-full ${selectedPack === 0 ? 'bg-[#111633] border-2 border-[#22c55e] shadow-[0_0_30px_rgba(34,197,94,0.2)]' : 'bg-[#0d1229] border-2 border-[#1e2a5a] hover:border-[#3b82f6]/50'}`} data-id="element-225">
              <div className={`absolute top-3 right-3 w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center ${selectedPack === 0 ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-600'}`} data-id="element-226">
                {selectedPack === 0 && <Check className="w-3 h-3 md:w-4 md:h-4 text-white" data-id="element-227" />}
              </div>
              <div className="text-2xl md:text-3xl mb-1" data-id="element-228">📚</div>
              <h3 className="text-lg md:text-2xl font-black text-white mb-1 pr-7" data-id="element-229">
                Kit Completo{' '}
                <span className="text-[#3b82f6]" data-id="element-230">Economía Política</span>
              </h3>
              <p className="text-gray-400 text-xs md:text-base mb-3 flex-1" data-id="element-231">
                6 tomos completos + 4 bonus
              </p>
              <div className="mt-auto pt-3 border-t border-[#1e2a5a]" data-id="element-232">
                <span className="text-gray-500 text-xs md:text-base line-through block" data-id="element-233">
                  $39.990
                </span>
                <span className="text-3xl md:text-5xl font-black text-white" data-id="element-234">
                  $19.990
                </span>
              </div>
            </button>

            {/* Option 2: Premium */}
            <button onClick={() => setSelectedPack(1)} className={`relative text-left rounded-2xl p-4 md:p-8 transition-all duration-200 cursor-pointer flex flex-col h-full ${selectedPack === 1 ? 'bg-[#111633] border-2 border-[#22c55e] shadow-[0_0_30px_rgba(34,197,94,0.2)]' : 'bg-[#0d1229] border-2 border-[#1e2a5a] hover:border-[#3b82f6]/50'}`} data-id="element-235">
              <span className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-[#eab308] text-black text-[10px] md:text-sm font-black px-3 py-0.5 rounded-full uppercase tracking-wider whitespace-nowrap shadow-[0_0_15px_rgba(234,179,8,0.4)]" data-id="element-236">
                ⭐ Más elegido
              </span>
              <div className={`absolute top-3 right-3 w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center ${selectedPack === 1 ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-600'}`} data-id="element-237">
                {selectedPack === 1 && <Check className="w-3 h-3 md:w-4 md:h-4 text-white" data-id="element-238" />}
              </div>
              <div className="text-2xl md:text-3xl mb-1" data-id="element-239">🎓</div>
              <h3 className="text-lg md:text-2xl font-black text-white mb-1 pr-7" data-id="element-240">
                Kit Completo +{' '}
                <span className="text-[#eab308]" data-id="element-241">Academia de Simulación</span>
              </h3>
              <p className="text-gray-400 text-xs md:text-base mb-3 flex-1" data-id="element-242">
                Kit completo + 4 proyectos de inmersión + 20 escenarios de
                crisis
              </p>
              <div className="mt-auto pt-3 border-t border-[#1e2a5a]" data-id="element-243">
                <span className="text-gray-500 text-xs md:text-base line-through block" data-id="element-244">
                  $59.990
                </span>
                <span className="text-3xl md:text-5xl font-black text-white" data-id="element-245">
                  $27.990
                </span>
              </div>
            </button>
          </div>

          <div className="text-center" data-id="element-246">
            <a href={packLinks[selectedPack]} className="inline-flex items-center justify-center gap-2 w-full md:w-auto bg-[#22c55e] hover:bg-[#16a34a] text-white font-black text-lg md:text-3xl py-3 px-6 md:py-6 md:px-20 rounded-xl shadow-[0_0_40px_rgba(34,197,94,0.4)] transform hover:scale-[1.02] transition-all duration-200 border-2 border-[#4ade80] uppercase tracking-wide" data-id="element-247">
              → SÍ, QUIERO MI PACK
            </a>
            <p className="text-gray-400 text-xs md:text-base font-bold mt-3 flex items-center justify-center gap-2" data-id="element-248">
              <Lock className="w-4 h-4 text-[#22c55e]" data-id="element-249" /> PAGO SEGURO CON
              MERCADO PAGO
            </p>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-[#050812] text-gray-500 py-4 md:py-10 px-3 text-center text-xs md:text-sm border-t border-[#1e2a5a]" data-id="element-250">
        <p className="mb-2 md:mb-4 font-bold" data-id="element-251">
          © 2025 Kit Completo Economía Política™
        </p>
        <div className="flex flex-wrap justify-center gap-3 md:gap-8" data-id="element-252">
          <span className="hover:text-[#22c55e] cursor-pointer transition-colors" data-id="element-253">
            Términos y Condiciones
          </span>
          <span className="hover:text-[#22c55e] cursor-pointer transition-colors" data-id="element-254">
            Política de Privacidad
          </span>
          <span className="hover:text-[#22c55e] cursor-pointer transition-colors" data-id="element-255">
            Soporte
          </span>
        </div>
      </footer>
    </div>;
}